import { Shift } from "Models/Shifts/Shift";
import { Action } from "redux";

export const enum ActionTypes {
    HAS_AREA_SHIFTS_RETRIEVED = "HAS_AREA_SHIFTS_RETRIEVED",
    COMPANY_SHIFTS_RETRIEVED = "COMPANY_SHIFTS_RETRIEVED",
    AREA_SHIFTS_RETRIEVED = "AREA_SHIFTS_RETRIEVED"
}

export interface IHasAreaShiftsRetrievedAction extends Action {
    type: ActionTypes.HAS_AREA_SHIFTS_RETRIEVED;
    hasAreaShifts: boolean;
}

export interface ICompanyShiftsRetrievedAction extends Action {
    type: ActionTypes.COMPANY_SHIFTS_RETRIEVED;
    companyShifts: Shift[];
}

export interface IAreaShiftsRetrievedAction extends Action {
    type: ActionTypes.AREA_SHIFTS_RETRIEVED;
    areaShifts: Shift[];
}

export type ShiftActions = IHasAreaShiftsRetrievedAction | ICompanyShiftsRetrievedAction | IAreaShiftsRetrievedAction;


// WEBPACK FOOTER //
// ./src/Store/Shifts/ShiftActionTypes.ts